module.exports = __webpack_public_path__ + "img/bubble.9410581.png";